// src/pages/LoginPage.js
import React from "react";
import Login from "../containers/Auth/LoginForm";

export default function LoginPage() {
  return <Login />;
}
